export class CsvService {
  public parseCsvText(text: string, headers: string[]): Record<string, string>[] {
    const lines = text.trim().split("\n"); // テキストを行ごとに分割
    const result: Record<string, string>[] = [];
    let currentLine = "";

    for (let i = 0; i < lines.length; i++) {
      currentLine += lines[i];
      if (this.isLineComplete(currentLine)) {
        const parsedLine = this.parseCsvLine(currentLine);
        const obj = this.createObjectFromLine(parsedLine, headers);
        result.push(obj);
        currentLine = "";
      } else {
        currentLine += "\n"; // ダブルクォート内の改行を維持
      }
    }

    // 残った行を処理
    if (currentLine) {
      const parsedLine = this.parseCsvLine(currentLine);
      const obj = this.createObjectFromLine(parsedLine, headers);
      result.push(obj);
    }

    return result;
  }

  private isLineComplete(line: string): boolean {
    let inQuotes = false;
    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      if (char === '"') {
        if (i > 0 && line[i - 1] === '"' && inQuotes) {
          // ダブルクォートがエスケープされた場合
          i++;
        } else {
          inQuotes = !inQuotes;
        }
      }
    }
    return !inQuotes;
  }

  private parseCsvLine(line: string): string[] {
    const result: string[] = [];
    let currentCell = "";
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      const nextChar = line[i + 1];

      if (inQuotes) {
        if (char === '"' && nextChar === '"') {
          // エスケープされたダブルクォート
          currentCell += char;
          i++; // 次のダブルクォートをスキップ
        } else if (char === '"') {
          // 終了ダブルクォート
          inQuotes = false;
        } else {
          currentCell += char;
        }
      } else {
        if (char === '"') {
          // 開始ダブルクォート
          inQuotes = true;
        } else if (char === "," || char === "	") {
          // セル区切り
          result.push(currentCell);
          currentCell = "";
        } else {
          currentCell += char;
        }
      }
    }

    // 最後のセルを追加
    result.push(currentCell);

    return result;
  }

  private createObjectFromLine(parsedLine: string[], headers: string[]): Record<string, string> {
    const obj: Record<string, string> = {};
    headers.forEach((header, index) => {
      obj[header] = parsedLine[index] || "";
    });
    return obj;
  }
}



// WEBPACK FOOTER //
// ./src/providers/csv.service.ts